import { FormattedMessage } from 'react-intl';
import { Schema } from 'src/utils/form';

const schema = Schema.object({
  dataIndicacao: Schema.string()
    .label(<FormattedMessage id="labelDataIndicacao" />)
    .required(),
  colaborador: Schema.string()
    .label(<FormattedMessage id="colaborador" />)
    .required(),
  indicador: Schema.string().label(<FormattedMessage id="indicadoPor" />),
  tempoSucessao: Schema.string()
    .label(<FormattedMessage id="tempoParaSuceder" />)
    .required(),
  justificativa: Schema.string()
    .label(<FormattedMessage id="justificativa" />)
    .required(),
});

export default schema;
